import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { TreeviewComponent } from '../app/components/treeview/treeview.component';
import { ElementOptionsComponent } from '../app/resources/element/element-options/element-options.component';
import { UserIconComponent } from '../app/components/user-icon/user-icon.component';
import { ModalService } from '../app/services/modal/modal.service';
import { ProjectStore } from '../app/utilities/stores/project/project-store';
import { ProjectElementStore } from '../app/utilities/stores/project-element/project-element-store';
import { ProjectModuleStore } from '../app/utilities/stores/project-module/project-module-store';
import { ProjectSubmoduleStore } from '../app/utilities/stores/project-submodule/project-submodule-store';
import { AreaStore } from '../app/utilities/stores/area/area-store';
import { BasicAreaStore } from '../app/utilities/stores/basicarea/basicarea-store';
import { BuildingStore } from '../app/utilities/stores/building/building-store';
import { ClusterStore } from '../app/utilities/stores/cluster/cluster-store';
import { UserStore } from '../app/utilities/stores/user/user-store';
import { ProjectInitializerService } from '../app/utilities/stores/project/project-initializer.service';
import { ElementLogStore } from '../app/utilities/stores/element-log/element-log-store';
import { ProjectStoreService } from '../app/utilities/stores/project/project.service';
import { ProjectElementService } from '../app/utilities/stores/project-element/project-element.service';
import { ProjectModuleService } from '../app/utilities/stores/project-module/project-module.service';
import { ProjectSubmoduleService } from '../app/utilities/stores/project-submodule/project-submodule.service';

import { PveTemplateStore } from '../app/utilities/stores/pve-template/pve-template-store';
import { AreaTemplateStore } from '../app/utilities/stores/area-template/area-template-store';
import { BuildingTemplateStore } from '../app/utilities/stores/building-template/building-template-store';
import { InlineEditAreaFunctionalityComponent } from '../app/components/inline-edit/area-functionality/area-functionality.component';

// import { DeviceDetectComponent } from '../app/components/device-detect/device-detect.component';

import { FloorAreaService } from '../app/services/floor-area/floor-area.service';
import { BuildingInfoRatioComponent } from '../app/views/areas/building/building-info-ratio/building-info-ratio.component';
import { ClusterInfoRatioComponent } from '../app/views/areas/building/cluster-info-ratio/cluster-info-ratio.component';
import { ProjectService } from '../app/resources/project/project.service';
import { BuildingOptionsComponent } from '../app/resources/building/building-options/building-options.component';
import { ElementService } from '../app/resources/element/element.service';
import { AreaService } from '../app/resources/area/area.service';
import { TranslateService } from '../app/utilities/translate/translate.service';
import { AuthService } from '../app/auth/auth.service';
import { UserService } from '../app/resources/user/user.service';
import { ProjectInfoViewComponent } from '../app/views/info/project-info-view/project-info-view.component';
import { ProjectInfoElementComponent } from '../app/views/info/project-info-element/project-info-element.component';
import { ProjectInfoToolbarComponent } from '../app/views/info/project-info-toolbar/project-info-toolbar.component';
import { ProjectInfoIndexComponent } from '../app/views/info/project-info-index/project-info-index.component';
import { ModuleOptionsComponent } from '../app/resources/module/module-options/module-options.component';
import { SubmoduleOptionsComponent } from '../app/resources/submodule/submodule-options/submodule-options.component';
import { ApiService } from '../app/api/api.service';
import { ElementViewComponent } from '../app/views/elements/element-view/element-view.component';
import { RouterService } from '../app/utilities/router/router.service';
import { ElementSidebarComponent } from '../app/resources/element/element-sidebar/element-sidebar.component';
import { ElementSidebarService } from '../app/resources/element/element-sidebar/element-sidebar.service';
import { ElementValueComponent } from '../app/resources/element/element-value/element-value.component';
import { AdminToolsViewComponent } from '../app/views/admin/admin-tools-view/admin-tools-view.component';
import { CircularDetectionService } from '../app/utilities/circular-detection/circular-detection.service';
import { AreaDetailsViewComponent } from '../app/views/areas/area/area-details-view/area-details-view.component';
import { MatrixService } from '../app/services/matrix/matrix.service';
import { ElementsViewComponent } from '../app/views/elements/elements-view/elements-view.component';
import { ProjectTemplateService } from '../app/resources/project-template/project-template.service';
import { BuildingTemplateService } from '../app/resources/building-template/building-template.service';
import { LogService } from '../app/resources/log/log.service';
import { ModuleService } from '../app/resources/module/module.service';
import { AreasViewComponent } from '../app/views/areas/areas/areas-view/areas-view.component';
import { ApiLegacyService } from '../app/api/legacy/api-legacy.service';
import { BuildingService } from '../app/resources/building/building.service';
import { BasicAreaService } from '../app/resources/basic-area/basic-area.service';


angular.module('specsguardApp')

  // Views
  .directive(
    'sg2AdminToolsView',
    downgradeComponent({ component: AdminToolsViewComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2AreaDetailsView',
    downgradeComponent({ component: AreaDetailsViewComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2AreasView',
    downgradeComponent({ component: AreasViewComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ElementViewComponent',
    downgradeComponent({ component: ElementViewComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ElementsViewComponent',
    downgradeComponent({ component: ElementsViewComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ProjectInfoView',
    downgradeComponent({ component: ProjectInfoViewComponent }) as angular.IDirectiveFactory
  )

  // Components
  .directive(
    'sg2BuildingOptions',
    downgradeComponent({ component: BuildingOptionsComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2BuildingInfoRatio',
    downgradeComponent({ component: BuildingInfoRatioComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ClusterInfoRatio',
    downgradeComponent({ component: ClusterInfoRatioComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ElementOptions',
    downgradeComponent({ component: ElementOptionsComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ElementSidebar',
    downgradeComponent({ component: ElementSidebarComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ElementValue',
    downgradeComponent({ component: ElementValueComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2InlineEditAreaFunctionality',
    downgradeComponent({ component: InlineEditAreaFunctionalityComponent }) as angular.IDirectiveFactory
  )
  // .directive(
  //   'sg2DeviceDetectComponent',
  //   downgradeComponent({component: DeviceDetectComponent}) as angular.IDirectiveFactory
  // )
  .directive(
    'sg2ModuleOptions',
    downgradeComponent({ component: ModuleOptionsComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ProjectInfoElement',
    downgradeComponent({ component: ProjectInfoElementComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ProjectInfoIndex',
    downgradeComponent({ component: ProjectInfoIndexComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2ProjectInfoToolbar',
    downgradeComponent({ component: ProjectInfoToolbarComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2SubmoduleOptions',
    downgradeComponent({ component: SubmoduleOptionsComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2Treeview',
    downgradeComponent({ component: TreeviewComponent }) as angular.IDirectiveFactory
  )
  .directive(
    'sg2UserIcon',
    downgradeComponent({ component: UserIconComponent }) as angular.IDirectiveFactory
  )

  // Services
  .service(
    'sg2ApiLegacyService',
    downgradeInjectable(ApiLegacyService) as any
  )
  .service(
    'sg2AuthService',
    downgradeInjectable(AuthService) as any
  )
  .service(
    'sg2ElementSidebarService',
    downgradeInjectable(ElementSidebarService) as any
  )
  .service(
    'sg2FloorAreaService',
    downgradeInjectable(FloorAreaService) as any
  )
  .service(
    'sg2ModalService',
    downgradeInjectable(ModalService) as any
  )
  .service(
    'sg2MatrixService',
    downgradeInjectable(MatrixService) as any
  )

  // Utilities
  .service(
    'sg2CircularDetectionService',
    downgradeInjectable(CircularDetectionService) as any
  )
  .service(
    'sg2RouterService',
    downgradeInjectable(RouterService) as any
  )
  .service(
    'sg2TranslateService',
    downgradeInjectable(TranslateService) as any
  )

  // Stores
  .service(
    'sg2AreaService',
    downgradeInjectable(AreaService) as any
  )
  .service(
    'sg2BuildingService',
    downgradeInjectable(BuildingService) as any
  )
  .service(
    'sg2AreaTemplateService',
    downgradeInjectable(BasicAreaService) as any
  )
  .service(
    'sg2BuildingTemplateService',
    downgradeInjectable(BuildingTemplateService) as any
  )
  .service(
    'sg2ElementService',
    downgradeInjectable(ElementService) as any
  )
  .service(
    'sg2LogService',
    downgradeInjectable(LogService) as any
  )
  .service(
    'sg2ModuleService',
    downgradeInjectable(ModuleService) as any
  )
  .service(
    'sg2ProjectService',
    downgradeInjectable(ProjectService) as any
  )
  .service(
    'sg2ProjectTemplateService',
    downgradeInjectable(ProjectTemplateService) as any
  )
  .service(
    'sg2UserService',
    downgradeInjectable(UserService) as any
  )

  // Stores (legacy)
  // @deprecated Please do not use anymore.
  .service(
    'ProjectStore',
    downgradeInjectable(ProjectStore) as any
  )
  .service(
    'ProjectInitializerService',
    downgradeInjectable(ProjectInitializerService) as any
  )
  .service(
    'ProjectStoreService',
    downgradeInjectable(ProjectStoreService) as any
  )
  .service(
    'ProjectElementStore',
    downgradeInjectable(ProjectElementStore) as any
  )
  .service(
    'sg2ProjectElementService',
    downgradeInjectable(ProjectElementService) as any
  )
  .service(
    'sg2ProjectModuleService',
    downgradeInjectable(ProjectModuleService) as any
  )
  .service(
    'sg2ProjectSubmoduleService',
    downgradeInjectable(ProjectSubmoduleService) as any
  )
  .service(
    'ProjectModuleStore',
    downgradeInjectable(ProjectModuleStore) as any
  )
  .service(
    'ProjectSubmoduleStore',
    downgradeInjectable(ProjectSubmoduleStore) as any
  )
  .service(
    'AreaStore',
    downgradeInjectable(AreaStore) as any
  )
  .service(
    'BasicAreaStore',
    downgradeInjectable(BasicAreaStore) as any
  )
  .service(
    'BuildingStore',
    downgradeInjectable(BuildingStore) as any
  )
  .service(
    'ClusterStore',
    downgradeInjectable(ClusterStore) as any
  )
  .service(
    'ElementLogStore',
    downgradeInjectable(ElementLogStore) as any
  )
  .service(
    'UserStore',
    downgradeInjectable(UserStore) as any
  )
  .service(
    'AreaTemplateStore',
    downgradeInjectable(AreaTemplateStore) as any
  )
  .service(
    'BuildingTemplateStore',
    downgradeInjectable(BuildingTemplateStore) as any
  )
  .service(
    'PveTemplateStore',
    downgradeInjectable(PveTemplateStore) as any
  );
